var Mn = require('backbone.marionette'),
    Layout = require('./views/Layout'),
    Default = require('./views/Default'),
    Router = require('./libs/router'),
    helpers = require('./libs/helpers'),
    scripts = require('simple-load-script').all,
    $ = require('jquery'),
    $body = $('body'),
    App = Mn.Application.extend({
        jquery: $,
        initialized: false,
        initialize: function () {
            this.router = new Router(this);
        },
        onStart: function () {
            var self = this;
            this.layout = new Layout({el: document.body});
            this.layout.triggerMethod('attach', this.layout);
            this.loading(true);
            this.setup({}, true, function(){
                self.loading(false);
            });

            $('#main').on('click', '.menu__nav__list', function(e){
                var target = $(e.currentTarget);
                target.addClass('active');
            });
        },
        _regions: {},
        views: function (views) {
            this._regions = views;
        },
        setup: function (data, firstRender, complete) {
            this.data = data;
            this.scripts(data.sections && data.sections.scripts, firstRender, complete);
        },
        scripts: function (html, firstRender, complete) {
            var all = firstRender ? $('html') : $('<div>' + html + '</div>'),
                self = this,
                difference = helpers.scripts_difference(all.find('script[data-dependency]'), $('script[src]')),
                callback = function () {
                    var run = all.find('script[data-run]');
                    if (run.length) {
                        if(!firstRender){
                            run.appendTo(document.body);
                            $(document.body).find('script[data-run]').remove();
                        }
                    } else {
                        self.views({});
                    }
                    self.regions(complete);
                };
            if (difference.length) {
                scripts(difference).then(callback);
            } else {
                callback();
            }
        },
        loading: function(status){
            if (status) {
                $body.addClass('loading');
            } else {
                $body.removeClass('loading');
            }
        },
        attach: function(_region, View) {

            // Tags Agência GDM
            !function(){var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="//configusa.veinteractive.com/tags/471856B0/2DE3/406A/9A7F/2BD90B3ACE9F/tag.js";var b=document.getElementsByTagName("head")[0];if(b)b.appendChild(a,b);else{var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)}}();!function(){var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="//configusa.veinteractive.com/tags/471856B0/2DE3/406A/9A7F/2BD90B3ACE9F/tag.js";var b=document.getElementsByTagName("head")[0];if(b)b.appendChild(a,b);else{var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)}}();

            var region = this.layout.getRegion(_region),
            current = region.currentView;
            if (current && this.data && this.data.sections && !this.data.sections[_region]) {
                region.empty();
                return false;
            } else {
                var view = this.getView(_region, View, current);
                return {
                    region: region,
                    view: view,
                    current: current
                };
            }
        },
        regions: function (complete) {
            var regions = this.layout.getRegions();
            for(var key in regions) {
                if (regions[key].currentView || regions[key].$el.children().length || (this.data && this.data.sections && this.data.sections[key])) {
                    var result = this.attach(key, this._regions[key] || Default);
                    if (result) {
                        result.region.show(result.view);

                        if (!result.current) {
                            result.view.triggerMethod('attach', result.view);
                        }
                    }
                }
            }
            complete && complete();
        },
        getView: function (_region, View, current) {
            if (View.factory && View.factory(current, this.data)) {
                return false;
            }
            var el = this.getElement(_region, current);
            var args = {data: this.data};
            args.el = el;
            var view = new View(args);
            return view;
        },
        getElement: function (_region) {
            var region = this.layout.getRegion(_region);
            if (this.data && this.data.sections && this.data.sections[_region]) {
                return $(helpers.content(this.data.sections[_region]));
            } else {
                return region.$el.children();
            }
        }
    });
module.exports  = new App();



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/app.js
// module id = 223
// module chunks = 3